<div class="detail" *ngIf="item && view"
     [class.red]="view.isLive && item.severity === 'red'"
     [class.orange]="view.isLive && item.severity === 'orange'"
     [class.yellow]="view.isLive && item.severity === 'yellow'"
     [class.green]="view.isLive && item.severity === 'green'"
     [class.done]="view.isDone || item.isStale">

  <div class="head">
    <span class="chip">{{ view.sourceChip }}</span>
    <span class="chip portfolio" *ngIf="view.portfolioChip" [title]="view.subjectLabel">{{ view.portfolioChip }}</span>
    <span class="badge overdue" *ngIf="view.overdue > 0">OVERDUE {{ view.overdue }} {{ view.overdue === 1 ? 'DAY' : 'DAYS' }}</span>
    <span class="tags" *ngIf="view.isDone">
      <span class="tag sev" *ngIf="view.severityLabel" [class.red]="item.severity === 'red'" [class.orange]="item.severity === 'orange'" [class.yellow]="item.severity === 'yellow'">{{ view.severityLabel }}</span>
      <span class="tag">{{ view.completionTag }}</span>
    </span>
    <span class="spacer"></span>
    <span class="tags" *ngIf="view.availabilityLabel"><span class="tag">{{ view.availabilityLabel }}</span></span>
    <span class="time">{{ view.originated }}</span>
    <button type="button" class="close" title="Close" (click)="close.emit()">✕</button>
  </div>

  <div class="headline">{{ view.headline }}</div>
  <div class="subject">{{ view.subjectLabel }}</div>
  <!-- An alert keeps its sender here, now that the chip says ALERTS (owner 2026-09-23). -->
  <div class="subject" *ngIf="view.sender">From {{ view.sender }}</div>

  <ul class="legs" *ngIf="view.legLines.length > 1">
    <li *ngFor="let line of view.legLines">{{ line }}</li>
  </ul>

  <div class="body" *ngIf="item.detail">{{ item.detail }}</div>

  <!-- Labels bold and dark, values regular (owner 2026-09-23). -->
  <div class="timeline">
    <div *ngIf="item.itemType !== 'AvailableAdjustment'"><span class="label">Due</span> {{ view.due }}</div>
    <div><span class="label">Delivered</span> {{ view.delivered }}</div>
    <div><span class="label">Read</span> {{ view.read }}</div>
    <div><span class="label">{{ item.itemType === 'AvailableAdjustment' ? 'Availability' : 'Verified' }}</span> {{ view.verified }}</div>
  </div>

  <div class="actions">
    <button type="button" class="action open" *ngIf="view.canOpen" (click)="openSubject.emit(item)">
      Open in {{ view.openPanelLabel }}
    </button>
    <span class="explain" *ngIf="view.canOpen">{{ view.openExplanation }}</span>

    <button type="button" class="action ack" *ngIf="view.canAcknowledge" [disabled]="!isOwnBoard"
            [title]="isOwnBoard ? 'Acknowledge this alert' : 'Only the recipient can acknowledge'"
            (click)="acknowledge.emit(item)">
      Acknowledge
    </button>

    <button type="button" class="action unread" *ngIf="canMarkUnread && item.readAtUtc && !item.completedAtUtc"
            title="Put this item back to unread" (click)="markUnread.emit(item)">
      Mark as unread
    </button>

    <button type="button" class="action withdraw" *ngIf="canWithdraw" (click)="withdraw.emit(item)"
            title="Withdraw this alert for every recipient who has not acknowledged it">
      Withdraw alert
    </button>
  </div>

  <!-- The audit trail (the record): super users only (owner 2026-09-22). -->
  <div class="record" *ngIf="showRecord && record && record.length > 0">
    <div class="record-title">Record</div>
    <ul class="record-list">
      <li *ngFor="let e of record">{{ formatEvent(e) }}</li>
    </ul>
  </div>

</div>
